import { whenHasValue } from 'src/shared/NullUtil';
import { VimeoParser } from 'src/shared/VimeoParser/VimeoParser';

export class VimeoLinkParser extends VimeoParser {

    constructor(nodeName: string, videoAttributeSourceName: string) {
        super(nodeName, videoAttributeSourceName);
    }

    public extract(url: string): string | null {
        return this.extractLink(url);
    }

    /**
     * Extracts the video id from the given url to vimeo link
     * @param url      The url to extract the video id from
     * @return         The video id if it can be extracted, otherwise `null`
     */
    private extractLink(url: string): string | null {
        // accepted is url starting with 'https://vimeo' then top level domain and slash
        // finally video id represented by number and optionally arguments
        // 'https://vimeo.com/12345678'
        return whenHasValue(url.match(/^(?:https:\/\/vimeo)\.[a-zA-Z]+\/(\d+)(.+)?/), (match) => {
            return this.parseVideoId(match);
        });
    }
}
